import { FileQuestion } from 'lucide-react';
import { Link } from 'react-router-dom';

import { Blueprint } from '@/components/ui/Blueprint';
import { Button } from '@/components/ui/Button';
import { EmptyState } from '@/components/ui/EmptyState';
import { ptBR } from '@/i18n/pt-BR';

export function NotFoundPage() {
  const t = ptBR.errorPages.notFound;
  return (
    <section
      data-testid="not-found-page"
      aria-labelledby="not-found-title"
      className="mx-auto max-w-2xl py-16"
    >
      <Blueprint className="px-8 py-10">
        <p
          data-testid="not-found-code"
          className="mb-2 text-center font-mono text-caption uppercase tracking-[0.02em] text-fg-dim"
        >
          {t.code}
        </p>
        <EmptyState
          icon={FileQuestion}
          title={t.title}
          description={t.body}
          action={
            <Button asChild variant="primary" size="default">
              <Link to="/" data-testid="not-found-back-cta">
                {t.backCta}
              </Link>
            </Button>
          }
          aria-labelledby="not-found-title"
          className="border-0 p-0"
        />
      </Blueprint>
      <h1 id="not-found-title" className="sr-only">
        {t.title}
      </h1>
    </section>
  );
}
